import { useMutation } from 'react-query';

import workspaceService from '@app/libs/workspaceService';
import {
  deleteInPersonSession,
  postStartInPersonSession,
} from '@app/store/transport-layer/document/documents/participants/session';

export default function useInPersonSessionRestart() {
  return useMutation<
    void,
    Error,
    {
      documentId: string;
      participantId: string;
    }
  >(mutate);
}

const mutate = async ({
  documentId,
  participantId,
}: {
  documentId: string;
  participantId: string;
}) => {
  const workspaceId = workspaceService.getWorkspaceId();
  await deleteInPersonSession({ documentId, participantId, workspaceId });
  await postStartInPersonSession({ participantId, documentId, workspaceId });
};
